import * as React from 'react';
import { Footer } from '../common/Footer';
import { Responsive, Segment, Visibility } from 'semantic-ui-react';
import DesktopMenu from "./DesktopMenu";
import MobileMenu from './MobileMenu';

interface Props {
  id: string;
  activeMenu: string;
  renderHeroContent: (mobile: boolean) => JSX.Element;
}

interface State {
  fixed?: boolean;
}

export class HeroPageLayout extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
    }
  }

  hideFixedMenu = () => this.setState({ fixed: false })
  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { id, children, activeMenu, renderHeroContent } = this.props
    const { fixed } = this.state

    return <div id={id}>

      <Responsive minWidth={650}>

        <Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}>
          <Segment textAlign='center' style={{ minHeight: 700, padding: '1em 0em', backgroundColor: "#252525", position: "relative", overflow: "hidden" }} vertical>
            <DesktopMenu fixed={fixed} activeMenu={activeMenu} />
            {renderHeroContent(false)}
            <div className="corner-ribbon bottom-right blue shadow">Closed Beta</div>
          </Segment>
        </Visibility>

        {children}

      </Responsive>

      <Responsive maxWidth={650}>

        <Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}>
          <Segment textAlign='center' style={{ minHeight: 350, padding: '1em 0em', backgroundColor: "#252525", position: "relative", overflow: "hidden"  }} vertical>
            <MobileMenu fixed={fixed} activeMenu={activeMenu} />
            {renderHeroContent(true)}
            <div className="corner-ribbon bottom-right blue shadow">Closed Beta</div>
          </Segment>
        </Visibility>

        {children}
      </Responsive>

      <Footer />

    </div>
  }
}


// WEBPACK FOOTER //
// ./src/common/HeroPageLayout.tsx